import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=e60932ac&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e60932ac')) {
      api.createRecord('e60932ac', component.options)
    } else {
      api.reload('e60932ac', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=e60932ac&", function () {
      api.rerender('e60932ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sh5mi9b4R3kc/JS/comp/ImgFallback.vue"
export default component.exports